module.exports = __webpack_public_path__ + "img/ErrorIconMobile.4796350f.svg";